export class TiposPublicoPrioritario {
    id: number;
    descricao: string;
}